// Reminds a guest that their games live on this phone only, and that a free
// name keeps them. It never stands in the way of playing (Fahad: no sign-up
// wall), and it is not shown to anyone signed in.
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useUsername } from '../../hooks/useUsername';
import { readPlays } from '../../services/playHistory';
import { trackEvent } from '../../services/analyticsService';
import './GuestNudge.css';

const SIGNUP = '/login?signup=1';

const TEXT = 'Playing as a guest: your games are saved on this phone only. Sign up free to keep your name and scores on any phone.';

// Inline, under a result or on the history page.
export const GuestNudge = ({ compact = false }) => {
  const { isAuthenticated, isLoading } = useUsername();
  const { pathname } = useLocation();
  if (isLoading || isAuthenticated) return null;
  return (
    <div className={`gn ${compact ? 'gn-compact' : ''}`}>
      <span className="gn-text">{compact ? 'Saved on this phone only.' : TEXT}</span>
      <Link to={SIGNUP} className="gn-btn" onClick={() => trackEvent('guest_nudge', { action: 'clicked', place: pathname })}>Sign up free</Link>
    </div>
  );
};

// Once per device, after a guest's third finished game, outside any game.
const SEEN = 'opq-seen-guest-nudge';
const AFTER_GAMES = 3;

export const GuestNudgeToast = () => {
  const { isAuthenticated, isLoading } = useUsername();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isLoading || isAuthenticated || open) return undefined;
    let seen = true;
    try { seen = !!localStorage.getItem(SEEN); } catch (e) { /* storage blocked: stay quiet */ }
    if (seen || readPlays().length < AFTER_GAMES) return undefined;
    const t = setTimeout(() => {
      // Never on top of a game in play or of the new-game notice.
      if (document.body.classList.contains('game-fullscreen') || document.querySelector('.ngt')) return;
      try { localStorage.setItem(SEEN, String(Date.now())); } catch (e) { /* fine */ }
      setOpen(true);
      trackEvent('guest_nudge', { action: 'shown', place: 'toast' });
    }, 3000);
    return () => clearTimeout(t);
  }, [isLoading, isAuthenticated, pathname, open]);

  useEffect(() => {
    if (!open) return undefined;
    const t = setTimeout(() => setOpen(false), 15000);
    return () => clearTimeout(t);
  }, [open]);

  if (!open || isAuthenticated) return null;
  return (
    <div className="gn-toast" role="status">
      <span className="gn-toast-text">
        <strong>You've played {readPlays().length} games.</strong> Sign up free so you don't lose them.
      </span>
      <Link to={SIGNUP} className="gn-btn" onClick={() => { trackEvent('guest_nudge', { action: 'clicked', place: 'toast' }); setOpen(false); }}>Sign up</Link>
      <button type="button" className="gn-close" aria-label="Close" onClick={() => setOpen(false)}>×</button>
    </div>
  );
};

export default GuestNudge;
